import React from "react";

export const MassLiturgy = ({size = 20, ...props}) => {
	return (
		<svg viewBox="0 0 512 512" width={size} height={size} {...props}>
			<circle cx={340.083} cy={249.735} fill="#fed2a4" r={46.752} />
			<path
				d="M361.924 208.398a46.536 46.536 0 015.415 21.84c0 25.82-20.931 46.752-46.752 46.752a46.53 46.53 0 01-21.84-5.415c7.843 14.814 23.407 24.911 41.336 24.911 25.82 0 46.752-20.931 46.752-46.752 0-17.929-10.097-33.493-24.911-41.336z"
				fill="#ffbd86"
			/>
			<path
				d="M340.083 296.486c-46.436.002-84.083 37.632-84.083 84.069v79.552c0 12.588 10.204 22.792 22.792 22.792h122.582c12.588 0 22.792-10.204 22.792-22.792v-79.552c.001-46.437-37.646-84.067-84.083-84.069z"
				fill="#fe93d3"
			/>
			<circle cx={174.624} cy={249.735} fill="#fed2a4" r={46.752} />
			<path
				d="M196.465 208.398a46.536 46.536 0 015.415 21.84c0 25.82-20.931 46.752-46.752 46.752a46.53 46.53 0 01-21.84-5.415c7.843 14.814 23.407 24.911 41.336 24.911 25.82 0 46.752-20.931 46.752-46.752 0-17.929-10.097-33.493-24.911-41.336z"
				fill="#ffbd86"
			/>
			<path
				d="M174.624 296.486c-46.436.002-84.083 37.632-84.083 84.068v79.552c0 12.588 10.204 22.792 22.792 22.792h122.582c12.588 0 22.792-10.204 22.792-22.792v-79.552c.001-46.436-37.647-84.066-84.083-84.068z"
				fill="#ffe177"
			/>
			<path
				d="M258.708 460.107v-79.552c0-38.666-26.111-71.204-61.654-81.019-9.083 12.219-14.466 27.342-14.466 43.702a72.886 72.886 0 008.15 33.56c1.672 3.234.832 7.179-2.055 9.396a111.721 111.721 0 00-11.513 10.175c-2.881 2.923-7.626 2.923-10.508 0a111.715 111.715 0 00-11.512-10.174c-2.888-2.217-3.727-6.162-2.055-9.396a72.877 72.877 0 008.15-33.56c0-15.761-5.009-30.365-13.496-42.339-33.253 11.211-57.209 42.621-57.209 79.656v79.552c0 12.588 10.204 22.792 22.792 22.792h122.582c12.589-.001 22.794-10.205 22.794-22.793z"
				fill="#ffd15b"
			/>
			<path
				d="M256 460.107v-79.552c0-38.666 26.111-71.204 61.654-81.019 9.083 12.219 14.466 27.342 14.466 43.702a72.886 72.886 0 01-8.15 33.56c-1.672 3.234-.832 7.179 2.055 9.396a111.721 111.721 0 0111.513 10.175c2.881 2.923 7.626 2.923 10.508 0a111.715 111.715 0 0111.512-10.174c2.888-2.217 3.727-6.162 2.055-9.396a72.877 72.877 0 01-8.15-33.56c0-15.761 5.009-30.365 13.496-42.339 33.253 11.211 57.209 42.621 57.209 79.656v79.552c0 12.588-10.204 22.792-22.792 22.792H278.792C266.204 482.899 256 472.695 256 460.107z"
				fill="#fe73c5"
			/>
			<path
				d="M214.664 365.078l9.037 5.873 17.457 3.003 23.276-2.252 26.943-10.324 2.714-28.719-7.884-23.088-8.367-7.669a46.537 46.537 0 00-21.841-5.415c-25.82 0-46.752 20.932-46.752 46.752a46.533 46.533 0 005.417 21.839z"
				fill="#fed2a4"
			/>
			<path
				d="M277.84 301.901a46.536 46.536 0 015.415 21.84c0 25.82-20.931 46.752-46.752 46.752a46.53 46.53 0 01-21.84-5.415c7.843 14.814 23.407 24.911 41.336 24.911 25.82 0 46.752-20.931 46.752-46.752.001-17.928-10.097-33.492-24.911-41.336z"
				fill="#ffbd86"
			/>
			<path
				d="M126.751 512l2.581-.598 11.075-1.713 19.568-24.988-25.39-61.098-35.99-29.845-24.092-2.705c-40.1 6.389-70.753 41.106-70.753 83.006v15.15C3.75 501.796 13.954 512 26.542 512h95.922z"
				fill="#cb97e7"
			/>
			<path
				d="M87.833 389.99c-4.538 0-8.987.371-13.33 1.063 40.1 6.389 70.753 41.106 70.753 83.005v15.15c0 12.588-10.204 22.792-22.792 22.792h26.661c12.588 0 22.792-10.205 22.792-22.792l4.388-6.309-4.388-8.841c0-46.437-37.647-84.067-84.084-84.068z"
				fill="#bd80e1"
			/>
			<path
				d="M299.769 511.355l10.558-5.068 12.858-12.482v-44.58l-35.852-42.422-23.323-13.186-21.341-2.564c-40.1 6.389-70.753 41.106-70.753 83.006v15.15c0 12.588 10.204 22.792 22.792 22.792h99.194z"
				fill="#60b7ff"
			/>
			<path
				d="M256 389.99c-4.538 0-8.987.371-13.33 1.063 40.1 6.389 70.753 41.106 70.753 83.005v15.15c0 12.588-10.204 22.792-22.792 22.792h26.661c12.588 0 22.792-10.205 22.792-22.792l5.158-8.167-5.158-6.983c-.001-46.437-37.648-84.067-84.084-84.068z"
				fill="#26a6fe"
			/>
			<path
				d="M382.83 365.078l6.897 6.623 13.609 7.508 23.538 1.314 30.334-16.706 4.693-17.873-2.357-25.3-8.53-13.515-5.006-5.229a46.537 46.537 0 00-21.841-5.415c-25.82 0-46.752 20.932-46.752 46.752a46.53 46.53 0 005.415 21.841z"
				fill="#f6a96c"
			/>
			<path
				d="M446.007 301.901a46.536 46.536 0 015.415 21.84c0 25.82-20.931 46.752-46.752 46.752a46.53 46.53 0 01-21.84-5.415c7.843 14.814 23.407 24.911 41.336 24.911 25.82 0 46.752-20.931 46.752-46.752 0-17.928-10.097-33.492-24.911-41.336z"
				fill="#ea9b58"
			/>
			<path
				d="M467.626 510.886l15.204-4.13 14.172-27.615-4.223-28.147-25.622-37.528-25.481-18.02-18.865-4.394h-11.974c-40.1 6.389-70.753 41.106-70.753 83.006v15.15c0 12.588 10.204 22.792 22.792 22.792h98.884z"
				fill="#00f2a6"
			/>
			<path
				d="M424.167 389.99c-4.538 0-8.987.371-13.33 1.063 40.1 6.389 70.753 41.106 70.753 83.005v15.15c0 12.588-10.204 22.792-22.792 22.792h26.661c12.588 0 22.792-10.205 22.792-22.792v-15.15c-.001-46.437-37.648-84.067-84.084-84.068z"
				fill="#05e39c"
			/>
			<path
				d="M46.497 365.078l22.252 15.446 19.084-1.408 25.121-7.039 9.855-16.049 5.064-25.622-5.908-14.923-12.29-13.582a46.537 46.537 0 00-21.841-5.415c-25.82 0-46.752 20.932-46.752 46.752 0 7.891 1.963 15.32 5.415 21.84z"
				fill="#f6a96c"
			/>
			<path
				d="M109.674 301.901a46.536 46.536 0 015.415 21.84c0 25.82-20.931 46.752-46.752 46.752a46.53 46.53 0 01-21.84-5.415c7.843 14.814 23.407 24.911 41.336 24.911 25.82 0 46.752-20.931 46.752-46.752 0-17.928-10.097-33.492-24.911-41.336z"
				fill="#ea9b58"
			/>
			<g>
				<g fill="#00f2a6">
					<path d="M400.006 78.502a7.5 7.5 0 00-10.607-.001L377.45 90.449a7.497 7.497 0 00-2.197 5.304v39.037c-.465-.04-.932-.071-1.407-.071-9.061 0-16.406 7.345-16.406 16.406s7.345 16.406 16.406 16.406 16.407-7.345 16.407-16.406V98.859l9.752-9.751a7.5 7.5 0 00.001-10.606zM152.364 78.502a7.5 7.5 0 00-10.607-.001l-11.949 11.948a7.497 7.497 0 00-2.197 5.304v39.037c-.465-.04-.932-.071-1.406-.071-9.061 0-16.406 7.345-16.406 16.406s7.345 16.406 16.406 16.406 16.407-7.345 16.407-16.406V98.859l9.752-9.751a7.5 7.5 0 000-10.606z" />
				</g>
				<path
					d="M305.226 7.5a7.5 7.5 0 00-8.658-7.41l-65.639 10.254a7.5 7.5 0 00-6.342 7.41v59.545c-.465-.04-.932-.071-1.406-.071-9.061 0-16.407 7.345-16.407 16.406s7.345 16.406 16.407 16.406c9.061 0 16.406-7.345 16.406-16.406V24.173l50.639-7.91v50.782c-.465-.04-.932-.071-1.407-.071-9.061 0-16.406 7.345-16.406 16.406s7.345 16.406 16.406 16.406 16.407-7.345 16.407-16.406z"
					fill="#fe93d3"
				/>
			</g>
		</svg>
	);
}

export default MassLiturgy;
